// extracted by mini-css-extract-plugin
export default {"container":"styles_container__quNir","title":"styles_title__2ZCpC"};